import { MenuItemType } from '@/layouts/private/topBar/components/sideBarMenu/model/SideBarMenuItems.model.tsx';

export type PageTitlesTranslation = {
  backTo: string;
  discovery: string;
  experienceCompanies: string;
  knowMe: string;
  processDetails: string;
} & Record<MenuItemType, string>;

export const pageTitlesTranslation: PageTitlesTranslation = {
  analysisRemarks: 'Analysis Remarks',
  backTo: 'Back to',
  discovery: 'Discovery',
  experienceCompanies: 'Experience Companies',
  interviewSimulation: 'Interview Simulation',
  knowMe: 'KnowMe',
  meetings: 'Meetings',
  processDetails: 'Process Details',
  processes: 'Processes',
  processTemplates: 'Process Templates',
  statistics: 'Statistics',
};
